import WarehouseOrderRoute from '../warehouse/WarehouseOrderRoute'

const cardExtensions = {
    warehouseOrderRoute: WarehouseOrderRoute,
}

export default cardExtensions
